import { render } from "./StoreStatisticDetail.vue?vue&type=template&id=6b83e2c8&ts=true"
import script from "./StoreStatisticDetail.vue?vue&type=script&lang=ts"
export * from "./StoreStatisticDetail.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__